import type {FieldPath, FieldValues} from 'react-hook-form';
import {useController} from 'react-hook-form';

import {AutoResizeTextarea, type AutoResizeTextareaProps} from '../../index';

export type FieldAutoResizeTextareaProps<TName> = Omit<AutoResizeTextareaProps, 'name'> & {
  name: TName;
};

export const FieldAutoResizeTextarea = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  ...rest
}: FieldAutoResizeTextareaProps<TName>) => {
  const {field} = useController({name});

  return <AutoResizeTextarea {...field} value={field.value || ``} {...rest} />;
};
